const Bengless = [
  {
    id: 1,
    name: "Elegant Gold Bangle with Floral Design",
    image: "images/bengle3.JPG",
    price: 250,
    alt: "Elegant Gold Bangle with Floral Design",
  },
  {
    id: 2,
    name: "Classic Gold Bangle",
    image: "images/bengle4.JPG",
    price: 350,
    alt: "Classic Gold Bangle",
  },
  {
    id: 3,
    name: "Stylish Gold Bangle with Gemstones",
    image: "images/bengle2.JPG",
    price: 450,
    alt: "Stylish Gold Bangle with Gemstones",
  },
  {
    id: 4,
    name: "Traditional Gold Bangle",
    image: "images/bengle1.JPG",
    price: 360,
    alt: "Traditional Gold Bangle",
  },
];

export default Bengless;
